import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { platformApi } from '../../lib/platformApi.js';
import { ChangePasswordCard } from '../settings/ChangePasswordCard.js';

/** Platform-admin self-service password change. */
export function PlatformChangePasswordPage(): JSX.Element {
  const { t } = useTranslation('platform');
  return (
    <div className="mx-auto flex max-w-lg flex-col gap-4">
      <Link
        to="/platform/tenants"
        className="inline-flex items-center gap-1 text-xs text-fg-muted underline-offset-2 hover:text-fg hover:underline"
      >
        <ArrowLeft className="h-3 w-3 rtl:rotate-180" aria-hidden />
        {t('tenants.title', { defaultValue: 'Tenants' })}
      </Link>
      <ChangePasswordCard
        submit={async (currentPassword, newPassword) => {
          await platformApi().post('/auth/change-password', { currentPassword, newPassword });
        }}
      />
    </div>
  );
}
